import { Heading, SimpleGrid, Spacer, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import Section from "../primary/Section";
import { ServiceItem } from "./ServiceItem";
import { servicesList } from "./ServicesData";

const Services = () => {
  return (
    <Section id="services-expand">
      <Spacer h={{ base: 10, md: 20 }} />
      <Heading fontSize={["2xl", "3xl"]}>VAD VI ERBJUDER</Heading>
      <Spacer h={4} />
      <Text color="lp_grey.500" as="p" fontSize="md" fontWeight="normal">
        Förutom de följande färdiga kurser och material erbjuder vi möjligheten att tillsammans med den berörda organisationen utveckla verksamhetsformer utifrån särskilda önskemål.
      </Text>
      <SimpleGrid
        columns={[1, 1, 2, 2, 3]}
        columnGap={6}
        rowGap={12}
        margin="0 auto"
        padding={{ base: "24px 0", md: "48px 0" }}
        color="lp_grey.600"
      >
        {servicesList.map((service, index) => (
          <motion.div
            key={service.slug}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.1 * index }}
            viewport={{ once: true }}
          >
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <ServiceItem {...service} />
            </motion.div>
          </motion.div>
        ))}
      </SimpleGrid>
    </Section>
  );
};
export default Services;
